import moment from 'moment';

import {
  LOAD_NOTIFICATIONS,
  SAVE_NOTIFICATIONS
} from '../constants/actionTypes';

import { getNotificationNewsByApp } from '../utils/apiHeader';

export const loadNotifications = dispatch =>
  new Promise(resolved => {
    getNotificationNewsByApp()
      .then(response => {
        // Remove notifications with typeAppNotification = null
        const { refresh, typeAppNotification } = response;
        const notificationsList = typeAppNotification.filter(
          obj => obj.typeAppNotification !== null
        );

        dispatch({
          type: LOAD_NOTIFICATIONS,
          notificationsList
        });

        resolved(refresh);
      })
      .catch(error => {
        throw error;
      });
  });

export const saveNotifications = (dispatch, notificationToShow) => {
  const notificationToShowUpdated = Array.from(notificationToShow);

  notificationToShow.map((notification, index) => {
    const sendDate = `${moment(notification.sendDate).format('DD/MM/YY')}`;
    notificationToShowUpdated[index].sendDate = sendDate;
    return undefined;
  });

  dispatch({
    type: SAVE_NOTIFICATIONS,
    notificationToShow: notificationToShowUpdated
  });
};
